<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add Business premise' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="businessPremiseForm" class="row add-premise-form">
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'Premise type' | translate }}</label>
          <select class="form-control" formControlName="type">
            <option [ngValue]="'realestate'">
              {{ 'Realestate' | translate }}
            </option>
            <option [ngValue]="'movable'">{{ 'Movable' | translate }}</option>
          </select>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'Premise ID' | translate }}</label>
          <input
            class="form-control"
            formControlName="businessPremiseId"
            placeholder="P1"
            [class.is-invalid]="
              sent && businessPremiseForm.get('businessPremiseId').errors
            "
            maxlength="20"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              sent &&
              businessPremiseForm.get('businessPremiseId').hasError('required')
            "
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
          <div
            class="invalid-feedback"
            *ngIf="
              sent &&
              businessPremiseForm.get('businessPremiseId').hasError('pattern')
            "
          >
            {{ 'furs.business-premise-add.businessPremiseId.invalid-format' | translate }}
          </div>
        </div>
      </div>
      <div
        class="col-12"
        *ngIf="businessPremiseForm.get('type').value === 'realestate'"
      >
        <div class="row">
          <div class="form-group col-6">
            <label>{{ 'Street' | translate }}</label>
            <input
              type="text"
              formControlName="street"
              class="form-control"
              placeholder="Tržaška cesta"
              [class.is-invalid]="
                sent && businessPremiseForm?.hasError('street')
              "
            />
            <div
              class="invalid-feedback"
              *ngIf="sent && businessPremiseForm?.hasError('street')"
            >
              {{ 'global.validators.required.error' | translate }}
            </div>
          </div>
          <div class="form-group col-6 col-md-3">
            <label>{{ 'Num' | translate }}</label>
            <input
              type="number"
              formControlName="houseNumber"
              class="form-control"
              placeholder="13"
              [class.is-invalid]="
                sent && businessPremiseForm?.hasError('houseNumber')
              "
            />
            <div
              class="invalid-feedback"
              *ngIf="sent && businessPremiseForm?.hasError('houseNumber')"
            >
              {{ 'global.validators.required.error' | translate }}
            </div>
          </div>
          <div class="form-group col-6 col-md-3">
            <label>{{ 'Additional' | translate }}</label>
            <input
              type="text"
              formControlName="houseNumberAdditional"
              class="form-control"
              placeholder="B"
            />
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-8"
        *ngIf="businessPremiseForm.get('type').value === 'realestate'"
      >
        <div class="row">
          <div class="form-group col-8">
            <label>{{ 'City' | translate }}</label>
            <input
              type="text"
              formControlName="city"
              class="form-control"
              placeholder="Ljubljana"
              [class.is-invalid]="sent && businessPremiseForm?.hasError('city')"
            />
            <div
              class="invalid-feedback"
              *ngIf="sent && businessPremiseForm?.hasError('city')"
            >
              {{ 'global.validators.required.error' | translate }}
            </div>
          </div>
          <div class="form-group col-4">
            <label>{{ 'Post' | translate }}</label>
            <input
              type="number"
              formControlName="postalCode"
              class="form-control"
              placeholder="1000"
              [class.is-invalid]="
                sent && businessPremiseForm?.hasError('postalCode')
              "
            />
            <div
              class="invalid-feedback"
              *ngIf="sent && businessPremiseForm?.hasError('postalCode')"
            >
              {{ 'global.validators.required.error' | translate }}
            </div>
            <div
              class="invalid-feedback"
              *ngIf="
                sent && businessPremiseForm?.get('postalCode').hasError('min')
              "
            >
              {{ 'Too short' | translate }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-4"
        *ngIf="businessPremiseForm.get('type').value === 'realestate'"
      >
        <div class="form-group">
          <label>{{ 'Community' | translate }}</label>
          <input
            type="text"
            formControlName="community"
            class="form-control"
            placeholder="Ljubljana"
            [class.is-invalid]="
              sent && businessPremiseForm?.hasError('community')
            "
          />
          <div
            class="invalid-feedback"
            *ngIf="sent && businessPremiseForm?.hasError('community')"
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
        </div>
      </div>
      <div
        class="col-12"
        *ngIf="businessPremiseForm.get('type').value === 'realestate'"
      >
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label>{{ 'Cadastral number' | translate }}</label>
              <input
                type="number"
                formControlName="cadastralNumber"
                class="form-control"
                placeholder="Codastral no."
                min="0"
                max="9999"
                [class.is-invalid]="
                  sent && (businessPremiseForm?.hasError('cadastralNumberRequired') || businessPremiseForm.hasError('cadastralNumberFormat'))
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="sent && businessPremiseForm?.hasError('cadastralNumberRequired')"
              >
                {{ 'global.validators.required.error' | translate }}
              </div>
              <div
                class="invalid-feedback"
                *ngIf="sent && businessPremiseForm?.hasError('cadastralNumberFormat')"
              >
                {{ 'furs.business-premise-add.cadastralNumber.invalid-format' | translate }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label>{{ 'Building number' | translate }}</label>
              <input
                type="number"
                formControlName="buildingNumber"
                class="form-control"
                placeholder="Building no."
                min="0"
                max="99999"
                [class.is-invalid]="
                  sent && (businessPremiseForm?.hasError('buildingNumberRequired') || businessPremiseForm?.hasError('buildingNumberFormat'))
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="sent && businessPremiseForm?.hasError('buildingNumberRequired')"
              >
                {{ 'global.validators.required.error' | translate }}
              </div>
              <div
                class="invalid-feedback"
                *ngIf="sent && businessPremiseForm?.hasError('buildingNumberFormat')"
              >
                {{ 'furs.business-premise-add.buildingNumber.invalid-format' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12"
        *ngIf="businessPremiseForm.get('type').value === 'movable'"
      >
        <div class="row">
          <div class="col-3">
            <div class="form-group">
              <label>{{ 'Type' | translate }}</label>
              <select
                class="form-control"
                formControlName="premiseType"
                [class.is-invalid]="
                  sent && businessPremiseForm?.hasError('premiseType')
                "
              >
                <option [ngValue]="null">Select</option>
                <option [ngValue]="'A'">A</option>
                <option [ngValue]="'B'">B</option>
                <option [ngValue]="'C'">C</option>
              </select>
              <div
                class="invalid-feedback"
                *ngIf="sent && businessPremiseForm?.hasError('premiseType')"
              >
                {{ 'global.validators.required.error' | translate }}
              </div>
            </div>
          </div>
          <div class="col">
            <label>{{ 'Movable premise types' | translate }}</label>
            <div class="card bg-light border">
              <div class="card-body">
                <p class="mb-1">{{ 'Type A' | translate }}</p>
                <p class="small text-muted mb-2">
                  {{ 'furs.business-premise-add.premiseType.a' | translate }}
                </p>
                <p class="mb-1">{{ 'Type B' | translate }}</p>
                <p class="small text-muted mb-2">
                  {{ 'furs.business-premise-add.premiseType.b' | translate }}
                </p>
                <p class="mb-1">{{ 'Type C' | translate }}</p>
                <p class="small text-muted mb-2">
                  {{ 'furs.business-premise-add.premiseType.c' | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-6"
        *ngIf="businessPremiseForm.get('type').value === 'realestate'"
      >
        <div class="form-group">
          <label>{{ 'Building section number' | translate }}</label>
          <input
            type="number"
            min="0"
            max="9999"
            formControlName="buildingSectionNumber"
            class="form-control"
            placeholder="Building section number"
            [class.is-invalid]="
              sent && (businessPremiseForm?.hasError('buildingSectionNumberRequired') || businessPremiseForm?.hasError('buildingSectionNumberFormat'))
            "
          />
          <div
            class="invalid-feedback"
            *ngIf="
              sent && businessPremiseForm?.hasError('buildingSectionNumberRequired')
            "
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
          <div
            class="invalid-feedback"
            *ngIf="sent && businessPremiseForm?.hasError('buildingSectionNumberFormat')"
          >
            {{ 'furs.business-premise-add.buildingSectionNumber.invalid-format' | translate }}
          </div>
        </div>
      </div>
      <div class="col-6" *ngIf="strategy === 'C'">
        <div class="form-group">
          <label>{{ 'Invoice first number' | translate }}</label>
          <input
            min="1"
            type="number"
            formControlName="lastNumber"
            class="form-control"
            placeholder="1"
            [class.is-invalid]="
              sent && businessPremiseForm?.hasError('lastNumber')
            "
          />
          <div
            class="invalid-feedback"
            *ngIf="sent && businessPremiseForm?.hasError('lastNumber')"
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span>{{ 'global.save' | translate }}</span>
      <span *ngIf="loading"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
